import { BindingCreator } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../translations';

const PATIENT_CONTENT_FIELD_NAME = 'patientConsent';

export type PatientConsent = 'WITH_CONSENT' | 'WITHOUT_CONSENT';
type PatientConsentFormBeanPart = {
   [PATIENT_CONTENT_FIELD_NAME]: PatientConsent;
};

type PatientConsentRadioGroupProps = {
   readonly register: BindingCreator<PatientConsentFormBeanPart, typeof PATIENT_CONTENT_FIELD_NAME>;
};

const items: RadioGroupItem<PatientConsent>[] = [
   {
      id: 'WITH_CONSENT',
      label: referralToPsychiatricHospitalTranslationKeys.withConsent,
   },
   {
      id: 'WITHOUT_CONSENT',
      label: referralToPsychiatricHospitalTranslationKeys.withoutConsent,
   },
];

export const PatientConsentRadioGroup = (props: PatientConsentRadioGroupProps): JSX.Element => {
   return (
      <RadioGroup
         testId={'patientConsent'}
         items={items}
         controller={props.register(PATIENT_CONTENT_FIELD_NAME, { required: true })}
         label={referralToPsychiatricHospitalTranslationKeys.patientExamination}
         horizontal
      />
   );
};
